<template>
  <div class="p-l-5">
    <div class="m-b-2 m-t-5">
      <strong>{{ columnDisplayName }}</strong>
    </div>

    <table class="table_beauty condensed-alternate routing-plan-args">
      <thead>
        <tr class="bg-transparent">
          <th class="text-right routing-plan-args__priority">
            Priority
          </th>
          <th class="text-right routing-plan-args__weight">
            Weight
          </th>
          <th>Name</th>
          <th v-if="columnName.toLowerCase() === 'ineligibletargets'">
            Reason
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(target, index) in parsedCallPlanDetail"
          :key="index"
          class="bg-transparent"
        >
          <td class="text-right">
            {{ target.priority }}
          </td>

          <td class="text-right">
            {{ target.weight }}
          </td>

          <td>{{ target.name }}</td>

          <td v-if="columnName.toLowerCase() === 'ineligibletargets'">
            {{ target.ineligibilityReason }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
const splitRegex = /(\[\d+,\s?\d+\])/gm;
const splitTargetsRegex = /(\[\d+,\s?\d+\],)/gm;

export default {
  name: 'RoutingPlanDetail',
  props: {
    targets: {
      type: String,
      default: '',
    },
    columnName: {
      type: String,
      default: '',
    },
    columnDisplayName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      parsedCallPlanDetail: [],
    };
  },
  watch: {
    targets: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          newValue = this.concatenateExtraneousLines(newValue);
          this.parsedCallPlanDetail = this.parseCallPlanDetail(
            this.getTargetsFromString(newValue)
          );
        }
      },
    },
  },
  methods: {
    concatenateExtraneousLines(string) {
      const lines = string.split(/\r?\n/);

      if (lines.length === 1) return string;

      const mergedRows = [];
      let currentRow = '';

      // whether the targets were eligible or ineligible
      const isEligible = this.columnName.toLowerCase() === 'eligibleorderedtargets';
      let pattern;

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();

        // Look for "Tag Fail" with Regex
        // Modify the pattern to ensure that the line ends with a ")"
        // This is the best way we have to determine when the end of a row is reached
        const tagFail = /Tag Fail/.test(line);
        if (tagFail) {
          pattern = /^(?!\[\d+,\d+\])[^\n]*?\[\d+,\d+\][^\n]*\)$/;
        } else {
          pattern = isEligible ? /^(.+?)\[(\d+),\s*(\d+)\]?$/ : /^(?!\[\d+,\d+\])[^\n]*?\[\d+,\d+\][^\n]*$/
        }

        if (pattern.test(line)) {
          if (currentRow) {
            mergedRows.push(currentRow.trim());
            currentRow = '';
          }

          // Always want to push the line if the pattern matches, but need to push the currentRow first above
          mergedRows.push(line);
        } else {
          // Pattern doesn't match, so accumulate the line into currentRow
          currentRow += line;
        }
      }

      // This is necessary incase there is accumulated currentRow that has not been pushed in the loop.
      if (currentRow) mergedRows.push(currentRow.trim());

      return mergedRows.join('\n');
    },
    getTargetsFromString(value) {
      let splited = value.split('\n');
      let targets = [];

      for (let j = 0; j < splited.length; j++) {
        if (splited[j]) {
          let splitString = splited[j].split(splitTargetsRegex);
          for (let i = 0; i < splitString.length; i += 2) {
            if (splitString[i]) {
              targets.push(`${splitString[i]}${splitString[i + 1] ? splitString[i + 1] : ''}`.replace(/,$/, ''));
            }
          }
        }
      }
      return targets;
    },
    parseCallPlanDetail(targets) {
      if (targets?.length) {
        return targets
          .map((target) => {
            target.replace('\n', '');
            let split = target.split(splitRegex);
            let priorityAndWeight = split[1].replace(/[\[\]]/g, '').split(',');

            return {
              name: split[0],
              priority: priorityAndWeight[0],
              weight: priorityAndWeight[1],
              ineligibilityReason: split[2] || '',
            };
          })
          .sort((targetA, targetB) => {
            var priorityComparison = targetA.priority - targetB.priority;

            if (priorityComparison == 0) {
              return targetA.weight - targetB.weight;
            }

            return priorityComparison;
          });
      }

      return [];
    },
  },
};
</script>

<style lang="scss" scoped>
.routing-plan-args__priority,
.routing-plan-args__weight {
  width: 45px;
}
</style>